import editorialStyle from "../../../components/editorial/style.scss";
import expandableStyle from "../../../components/expandable/style.scss";

import { Fragment } from "preact";
import Link, {
  Button,
  ButtonList,
  ButtonBar,
  LargeViewOnly,
  StickyButtons,
  affiliateMerchants,
} from "../../../components/link";
import AffiliateDisclosure from "../../../components/affiliate-disclosure";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import FixedTable from "../../../components/fixed-table";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import Tags from "../../../components/tags";
import ImageSet from "../../../components/image-set";
import Image from "../../../components/image";
import Author from "../../../components/author";
import EcoFlowCouponCode from "../components/coupon-code";
import NoWrap from "../../../components/no-wrap";
import SlugHeading from "../../../components/slug-heading";
import SlugLink from "../../../components/slug-link";
import Accordion from "../../../components/accordion";
import AccordionPreview from "../../../components/accordion/preview";
import PhotoListItem from "../../../components/photo-list-item";
import ReviewItem from "../../../components/review-item";
import Questions from "../../../components/questions";
import namedRoutes from "../../../settings/routes";
import { mergeClasses } from "../../../components/helpers";
import { lookupByUrl } from "../../../settings/route-data-lookup";

import AffiliateAd from "../../../components/affiliate-ad";

let headerInfo = lookupByUrl(namedRoutes.ecoflow.dp3);

const Page = () => (
  <div>
    <Head data={headerInfo} />
    <Hero
      positionX={0}
      positionY={85}
      background="/images/backgrounds/tabswiper3_img1.webp"
      titlePrefix="EcoFlow"
      title="DELTA Pro 3"
      subTitle="Vanlife Power Station Review"
    />
    <Editorial>
      <Center>
        <Author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />

        <LargeViewOnly>
          <ButtonList size="medium">
            <Button
              size="medium"
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105"
              icon="EcoFlow"
            >
              View on EcoFlow
            </Button>
            <Button
              size="medium"
              affiliate="https://amzn.to/3MkrPnm"
              href="https://www.amazon.com/dp/B0D14FMFZD/"
              secondary
              icon="Amazon"
            >
              View on Amazon
            </Button>
          </ButtonList>
        </LargeViewOnly>

        {/* <p>
          The <strong>EcoFlow DELTA Pro 3</strong> is a highly capable power
          station with solid performance and versatility. Having used both the
          DELTA Pro 3 and original DELTA Pro extensively in my personal van
          setup, I will go through the details of this product, important
          considerations, and how it compares to the previous model. It's a
          cutting-edge alternative to a DIY electrical system, saving
          significant time and money, without compromising on what's important.
        </p> */}
        <p>
          The <strong>EcoFlow DELTA Pro 3</strong> is a highly capable power
          station with solid performance and versatility. Having used both the
          DELTA Pro 3 and original DELTA Pro extensively in my personal van
          setup, I've found it to be a cutting-edge alternative to a DIY
          electrical system that saves significant time and money without
          compromising on what's important. In this review, I will cover the
          product details, important considerations, and how it compares to the
          previous model.
        </p>
        {/* <p>
          I will go through the details of what makes this product great and how
          it compares the previous DELTA Pro. I recently upgraded my van to use
          the DELTA Pro 3 from the original DELTA Pro and have put both power
          stations to the test. I now personally use this to power all my
          adventures on the road.
        </p> */}

        <AffiliateDisclosure />

        {/* <ImageSet
          border={true}
          images={[
            {
              lg: "/images/products/ecoflow/delta-pro-3/front.webp",
              alt: "",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/back.webp",
              alt: "",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/front-right.webp",
              alt: "",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/left.webp",
              alt: "",
            },
          ]}
        /> */}
        <ImageSet
          size={4}
          images={[
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1961.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1961.webp",
              alt: "DELTA Pro 3: front",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1962.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1962.webp",
              alt: "DELTA Pro 3: back",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1969.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1969.webp",
              alt: "DELTA Pro 3: front right",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1964.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1964.webp",
              alt: "DELTA Pro 3: left side",
            },
          ]}
        />

        <Accordion
          items={[
            {
              heading: "Table of Contents",
              content: (
                <ol>
                  <li>
                    <SlugLink>What's New</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Highlights</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Considerations</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Detailed Comparison</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Full Specifications</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Accessories</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>DC Fuse Panel</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Alternator Chargers</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Solar Panels</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Extra Batteries</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Other Accessories</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Suggestions to EcoFlow</SlugLink>
                  </li>
                  <li>
                    <SlugLink>My Verdict</SlugLink>
                  </li>
                </ol>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">System Example</SlugHeading>
        <ImageSet
          size={1}
          images={[
            {
              lg: "/images/diagrams/power-systems/ecoflow/ecoflow-delta-pro-3.webp?v=2",
              alt: "EcoFlow DELTA Pro 3 vanlife system diagram",
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">What's New</SlugHeading>
        <p>Notable improvements over the previous generation DELTA Pro:</p>
        <ul>
          <li>
            <strong>Increased capacity:</strong> Now 4,096Wh, which is a 496Wh
            increase over the original 3,600Wh.
          </li>
          <li>
            <strong>Additional solar port:</strong> Upgraded from a single solar
            input to two independent ports, separating high-voltage and
            low-voltage arrays for massive charging flexibility.
          </li>
          <li>
            <strong>Quiet operation:</strong> The redesigned thermal system is
            much quieter, often running completely fanless under normal loads.
            When the fans do kick on, they operate as low as 30dB. In a tight
            space where you sleep close to your gear, this silent operation is a
            massive upgrade over older, louder models.
          </li>
          <li>
            <strong>Ventilation direction:</strong> Airflow now moves
            front‑to‑back instead of side‑to‑side, freeing up valuable space
            beside the unit. Since the front and rear already need clearance for
            cables, this change reduces the overall space needed for
            installation.
          </li>
          <li>
            <strong>Increased AC output:</strong> Delivers 4,000W continuous
            pure sine wave output (up from 3,600W), with a massive 8,000W surge
            capacity.
          </li>
          <li>
            <strong>More AC outlets:</strong> Now natively includes a NEMA
            L14-30 twist-lock (120/240V~16.7A) and a NEMA 6-20 (240V~16.7A) port
            on the front of the unit. This brings 240V split-phase power to a
            single unit, eliminating the older generation's requirement of
            chaining two separate power stations together with an external hub
            just to get high‑voltage.
          </li>
          <li>
            <strong>Battery lifespan:</strong> Upgraded LFP (LiFePO4) cells
            boast 4,000 cycles to 80% health, an increase from 3,500 cycles on
            the original model.
          </li>
          <li>
            <strong>Faster UPS switchover speed:</strong> Ultra-fast sub-10ms
            automatic switching speed now keeps sensitive electronics or mobile
            work setups from shutting down when connected to the grid.
          </li>
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Highlights</SlugHeading>
        <ul>
          <li>
            <strong>Dual solar input ports:</strong> Features two independent
            solar inputs: high‑voltage port (30-150V⎓15A, 1,600W), low‑voltage
            port (11V-60V⎓20A, 1,000W). This provides the flexibility to support
            mismatched solar panels/arrays, deploy ground panels alongside a
            fixed roof array, or hook up a third-party alternator charger.
          </li>
          <li>
            <strong>High capacity and expandable:</strong> Scalable from its
            large 4,096Wh starting battery capacity up to an impressive 12.2kWh
            by adding EcoFlow expansion batteries.
          </li>
          <li>
            <strong>High AC output:</strong> Provides a robust 4,000W total
            continuous output (with 8,000W surge capacity), easily running heavy
            loads simultaneously such as induction cooktops, water heaters, or
            microwaves.
          </li>
          <li>
            <strong>30A RV port:</strong> Features a built-in NEMA TT-30R 30A AC
            outlet which is now on the left side of the unit. This lets you plug
            a standard RV power cord directly into the unit without adapters.
          </li>
          <li>
            <strong>Dedicated 30A DC output:</strong> Delivers a native
            12.6V⎓30A (378W max) via an Anderson Powerpole port to easily run a
            diesel heater and full 12V fuse block. This allows for high-amp 12V
            output, exceeding typical 10A cigarette socket limits.
          </li>
          <li>
            <strong>USB ports:</strong> Outfitted with 4x front-facing USB
            ports, including two 100W USB‑C PD ports alongside two 18W USB‑A
            ports.
          </li>
          {/* <li>1x DC5521 port (12.6V⎓DC 5A, 63W)</li> */}
          <li>
            <strong>Grid bypass mode:</strong> Routes AC shore power directly to
            your electronics. By skipping the internal battery, it prevents
            unnecessary wear while you are plugged in.
          </li>
          <li>
            <strong>Great value:</strong> Packs heavy-duty specs and advanced
            features at a much lower price point than an EcoFlow Power Kit or
            custom DIY build.
          </li>
          {/* <li>Wheels and collapsible handle</li> */}
          <li>
            <strong>External control screen support:</strong> Compatible with
            EcoFlow's{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-pro-remote-control?variant=39428709351497"
            >
              wired remote screen
            </Link>{" "}
            to monitor solar input, power usage, and battery level. It features
            physical buttons to quickly toggle AC and DC power on or off. This
            is a massive win for van builds, letting you locate the heavy unit
            out of sight without needing a Bluetooth phone app for daily tasks.
          </li>
          <li>
            <strong>EV station charging:</strong> Supports rapid charging at
            many EV charging stations using the optional{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/ev-x-stream-adapter-delta-pro-ultra?variant=40758561964105"
            >
              EV X-Stream Adapter
            </Link>
            . By connecting to the proprietary AC Power In/Out port located on
            the back, the adapter can pull up to 7,200W of input power, allowing
            you to top off the massive battery pack in under an hour while on
            road trips.
          </li>
        </ul>

        <AffiliateAd brand="EcoFlow" size="billboard" />
      </Center>
      <Center>
        <SlugHeading tag="h2">Considerations</SlugHeading>
        <ul>
          <li>
            <strong>No cigarette lighter port:</strong> EcoFlow removed the
            standard 12V socket entirely. To power common accessories like a 12V
            fridge, you will need to wire in a DC fuse block or source a
            3rd‑party{" "}
            <Link
              affiliate="https://amzn.to/4r0oie2"
              href="https://www.amazon.com/dp/B00AR08VOA/"
            >
              Anderson-to-cigarette adapter
            </Link>
            .
          </li>
          <li>
            <strong>Cable and port placement:</strong> Fortunately, most of the
            ports are located on the front and back of the unit. However, there
            are a few ports located on the side of the unit: DC Anderson
            Powerpole, DC5521, RJ45 for control screen, 30A AC plug. Cables
            protruding from the sides can easily get bumped or snagged in tight
            van layouts.
          </li>
          <li>
            <strong>Expansion limit:</strong> Since batteries cannot be chained
            together, the overall system capacity is capped at 12.2kWh via its
            two expansion ports (1 unit + 2 batteries).
          </li>
          <li>
            <strong>USB downsides:</strong> Only 4 USB ports (2x USB A, 2x USB
            C) vs original DELTA Pro with 6 USB ports. The high‑output USB‑C
            maxes out at 100W vs the DELTA Pro Ultra Plus at 140W.
          </li>
          <li>
            <strong>Shared DC output limits:</strong> The high-output 30A
            Anderson port shares its overall power pool with the USB ports,
            meaning they cannot all be maxed out simultaneously.
          </li>
          <li>
            <strong>Cold weather use:</strong> Like most power stations, it
            doesn't include internal self‑heating, so usage can be restricted if
            internal temperatures drop below 32°F.
          </li>
          <li>
            <strong>Size and weight:</strong> At 114 lbs (51.5 kg), this unit is
            best treated as a fixed installation rather than something you move
            often. It typically takes two people to lift into place. While the
            built-in dolly wheels make short rolling trips easy, the wheels
            protrude out the sides, preventing the unit from sitting flush
            against a wall.
          </li>
          <li>
            <strong>Cannot use 120V and 240V simultaneously:</strong> Activating
            the 240V outlets automatically cuts power to the 120V outlets,
            meaning you cannot draw both voltages at the exact same time.
          </li>
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Detailed Comparison</SlugHeading>
        <p>
          A side‑by‑side comparison with the most similar EcoFlow alternatives
          to the DELTA Pro 3:
        </p>

        <Fragment>
          <FixedTable>
            <table>
              <thead>
                <tr>
                  <th class={editorialStyle.sticky}>Model</th>
                  <th>DELTA Pro 3</th>
                  <th>DELTA Pro</th>
                  <th>DELTA 3 Ultra Plus</th>
                </tr>
                <tr style="font-style:italic;">
                  <th class={editorialStyle.sticky}>AKA</th>
                  <th>DP3</th>
                  <th>DP</th>
                  <th>D3U+</th>
                </tr>
              </thead>
              <tbody>
                <tr class={editorialStyle.noHover}>
                  <th class={editorialStyle.sticky}>
                    <strong>Photo</strong>
                  </th>
                  <td>
                    <Image
                      src="/images/products/ecoflow/delta-pro-3/front-right.webp"
                      alt="EcoFlow DELTA Pro 3"
                      showAlt
                      maxHeight={150}
                    />
                  </td>
                  <td>
                    <Image
                      src="/images/products/ecoflow/delta-pro/front-right.webp"
                      alt="EcoFlow DELTA Pro"
                      showAlt
                      maxHeight={150}
                    />
                  </td>
                  <td>
                    <Image
                      src="/images/products/ecoflow/delta-3-ultra-plus/front-right.webp"
                      alt="EcoFlow DELTA 3 Ultra Plus"
                      showAlt
                      maxHeight={150}
                    />
                  </td>
                </tr>
                <tr class={editorialStyle.noHover}>
                  <th class={editorialStyle.sticky}>
                    <strong>Links</strong>
                  </th>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-pro-3-portable-power-station"
                        icon="EcoFlow"
                      >
                        Store
                      </Button>
                      <Button
                        size="small"
                        external
                        href="https://manuals.ecoflow.com/us/product/delta-pro-3-portable-power-station?lang=en_US"
                        secondary
                      >
                        Manual
                      </Button>
                    </ButtonBar>
                  </td>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569"
                        icon="EcoFlow"
                      >
                        Store
                      </Button>
                      <Button
                        size="small"
                        external
                        href="https://manuals.ecoflow.com/us/product/delta-pro-portable-power-station?lang=en_US"
                        secondary
                      >
                        Manual
                      </Button>
                    </ButtonBar>
                  </td>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713&view=d3u"
                        icon="EcoFlow"
                      >
                        Store
                      </Button>
                      <Button
                        size="small"
                        external
                        href="https://manuals.ecoflow.com/cn/product/delta-3-ultra-plus?lang=en_US"
                        secondary
                      >
                        Manual
                      </Button>
                    </ButtonBar>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Price</strong>
                  </th>
                  <td>
                    <NoWrap>
                      $2,599 <s>$3,699</s>
                    </NoWrap>
                  </td>
                  <td>$1,499</td>
                  <td>
                    <NoWrap>
                      $1,499 <s>$2,899</s>
                    </NoWrap>
                  </td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>Capacity</strong>
                  </th>
                  <td>4,096Wh</td>
                  <td>3,600Wh</td>
                  <td>3,072Wh</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Extra battery</strong>
                  </th>
                  <td>2x</td>
                  <td>2x</td>
                  <td>
                    2x <sup>1</sup>
                  </td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>AC output</strong>
                  </th>
                  <td>
                    4,000W total <br />
                    8,000W surge
                  </td>
                  <td>
                    3,600W total <br />
                    7,200W surge
                  </td>
                  <td>
                    3,600W total <br />
                    7,200W surge
                  </td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>AC ports</strong>
                  </th>
                  <td>
                    ×4 (20A each)
                    <br />
                    ×1 (30A)
                    <br />
                    ×1 (120/240V~16.7A)
                    <br />
                    ×1 (240V~16.7A)
                  </td>
                  <td>
                    ×4 (20A each)
                    <br />
                    ×1 (30A)
                  </td>
                  <td>
                    ×4 (20A each)
                    <br />
                    ×1 (30A)
                  </td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>DC output</strong>
                  </th>
                  <td>12.6V⎓30A, 378W</td>
                  <td>12.6V⎓30A, 378W</td>
                  <td>12.6V⎓30A, 378W</td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>Anderson</strong>
                  </th>
                  <td>30A, 378W</td>
                  <td>30A, 378W</td>
                  <td>30A, 378W</td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>Cigarette</strong>
                  </th>
                  <td>--</td>
                  <td>8A, 100W</td>
                  <td>12.6V⎓10A, 126W</td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>DC5521</strong>
                  </th>
                  <td>5A</td>
                  <td>x2 3A, 38W</td>
                  <td>--</td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>Solar input 1</NoWrap>
                    </strong>
                  </th>
                  <td>
                    30-150V⎓15A
                    <br />
                    1,600W
                  </td>
                  <td>
                    11-150V⎓15A
                    <br />
                    1,600W
                  </td>
                  <td>
                    11-60V⎓18A
                    <br />
                    800W
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>Solar input 2</NoWrap>
                    </strong>
                  </th>
                  <td>
                    11V-60V⎓20A
                    <br />
                    1,000W
                  </td>
                  <td>--</td>
                  <td>
                    11-60V⎓18A
                    <br />
                    800W
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      Alternator input <sup>2</sup>
                    </strong>
                  </th>
                  <td>100-800W</td>
                  <td>100-800W</td>
                  <td>100-800W</td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>AC input</strong>
                  </th>
                  <td>15A 1,800W</td>
                  <td>15A 1,800W</td>
                  <td>15A 1,800W</td>
                </tr>
                <tr
                  class={mergeClasses([
                    editorialStyle.rowBorder,
                    expandableStyle.expandableHide,
                  ])}
                >
                  <th class={editorialStyle.sticky}>
                    <strong>USB A</strong>
                  </th>
                  <td>2x</td>
                  <td>4x</td>
                  <td>1x</td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>USB C</strong>
                  </th>
                  <td>2x</td>
                  <td>2x</td>
                  <td>3x</td>
                </tr>
                <tr
                  class={mergeClasses([
                    editorialStyle.rowBorder,
                    expandableStyle.expandableHide,
                  ])}
                >
                  <th class={editorialStyle.sticky}>
                    <strong>Size (in)</strong>
                  </th>
                  <td>27.3 × 13.4 × 16.2</td>
                  <td>25 × 11.2 × 16.4</td>
                  <td>24.1 × 12.9 × 15.6</td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>Size (mm)</strong>
                  </th>
                  <td>
                    <NoWrap>693 × 341 × 410.4</NoWrap>
                  </td>
                  <td>
                    <NoWrap>635 × 285 × 416</NoWrap>
                  </td>
                  <td>
                    <NoWrap>613.1 × 327.7 × 395</NoWrap>
                  </td>
                </tr>
                <tr class={expandableStyle.expandableHide}>
                  <th class={editorialStyle.sticky}>
                    <strong>Weight</strong>
                  </th>
                  <td>
                    <NoWrap>114lbs (51.5 kg)</NoWrap>
                  </td>
                  <td>
                    <NoWrap>99lbs (45kg)</NoWrap>
                  </td>
                  <td>
                    <NoWrap>74.3lbs (33.7kg)</NoWrap>
                  </td>
                </tr>
              </tbody>
            </table>
          </FixedTable>
          <p class="caption">
            <strong>1.</strong> Using the EcoFlow Extra Battery Expansion
            Adapter. <strong>2.</strong> Expected to increase to 1000W for each
            power station with the release of new{" "}
            <Link href={namedRoutes.ecoflow.altCharger.gen2}>
              gen 2 alternator chargers
            </Link>
            .
          </p>
        </Fragment>
        <br />

        <SlugHeading tag="h2">Full Specifications</SlugHeading>
        <Accordion
          headingsAs="h3"
          items={[
            {
              heading: "General",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Model:</strong> EFD521
                    </li>
                    <li>
                      <strong>Net Weight:</strong> 113.54 lbs (51.5 kg)
                    </li>
                    <li>
                      <strong>Dimensions:</strong> 27.3 × 13.4 × 16.2 in (693 ×
                      341 × 410.4 mm)
                    </li>
                    <li>
                      <strong>UL Certified:</strong>
                      <ul>
                        <li>
                          <strong>UL9540-Certified:</strong> Full-system
                          validation for electrical, mechanical, and
                          environmental resilience.
                        </li>
                        <li>
                          <strong>UL9540A-Certified:</strong> Proven resistance
                          to thermal runaway and fire spread—even in extreme
                          scenarios.
                        </li>
                        <li>
                          <strong>UL1973-Certified:</strong> Battery cells and
                          modules built to withstand overcharge, short circuits,
                          and long-term wear.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Warranty period:</strong> 5 years
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "AC Power",
              content: (
                <Fragment>
                  <Image
                    border
                    right
                    src="/images/products/ecoflow/delta-pro-3/ports.webp"
                    alt="AC Socket Types for US Version"
                  />
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      AC Output:
                      <ul>
                        <li>
                          <strong>Wave Form:</strong> Pure sine wave
                        </li>
                        <li>
                          <strong>Socket Type (US):</strong>
                          <ul class="none">
                            <li>
                              Low-voltage / Single phase:
                              <ul class="circle">
                                <li>4× NEMA 5-20R, 120V~20A</li>
                                <li>1× NEMA TT-30R, 120V~30A</li>
                              </ul>
                            </li>
                            <li>
                              High-voltage / Split phase:
                              <ul class="circle">
                                <li>1× NEMA L14-30R, 120/240V~16.7A</li>
                                <li>1× NEMA 6-20R, 240V~16.7A</li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Output Details (US):</strong>{" "}
                          <ul class="none">
                            <li>
                              Discharge Only:
                              <ul class="circle">
                                <li>120V~60Hz 4000W total (surge 8000W)</li>
                                <li>120/240V~60Hz 4000W total (surge 8000W)</li>
                              </ul>
                            </li>
                            <li>
                              Bypass Mode:
                              <ul class="circle">
                                <li>100-120V~50/60Hz 4000W total</li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>AC Power In/Out Port (US):</strong> EcoFlow
                          Proprietary Port
                          <ul class="circle">
                            <li>Discharge Only: 120/240V~16.7A 60Hz</li>
                          </ul>
                        </li>
                      </ul>
                      <hr />
                    </li>
                    <li>
                      AC Input:
                      <ul>
                        <li>
                          <strong>Socket Type (US):</strong> C20
                        </li>
                        <li>
                          <strong>Input Details (US):</strong>
                          <ul class="circle">
                            <li>Charge Only: 100-240V~15A 50/60Hz</li>
                            <li>
                              Bypass Mode: 100-120V~15A (3 hours Max), 12A
                              (continue), 50/60Hz
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>AC Power In/Out Port (US):</strong> EcoFlow
                          Proprietary Port
                          <ul class="circle">
                            <li>Charge Only: 100/200V-120/240V~20A 50/60Hz</li>
                          </ul>
                        </li>
                      </ul>
                      <hr />
                    </li>
                  </ul>
                  <p class="caption">
                    See{" "}
                    <Link
                      external
                      href="https://manuals.ecoflow.com/us/product/delta-pro-3-portable-power-station?lang=en_US#d5fbcaad-92cd-4e6f-ada8-fc443b4dd6ae"
                    >
                      product manual
                    </Link>{" "}
                    for other countries.
                  </p>
                </Fragment>
              ),
            },
            {
              heading: "DC Power",
              content: (
                <Fragment>
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      DC Output:
                      <ul>
                        <li>
                          <strong>USB Output:</strong>
                          <ul class="circle">
                            <li>
                              2 ×USB‑A (QC3.0): 5V⎓2.4A / 9V⎓2A / 12V⎓1.5A, 18W
                              Max per port, 36W total
                            </li>
                            <li>
                              2 ×USB‑C (PD3.0): 5 / 9 / 12 / 15V⎓3A、20V⎓5A,
                              100W Max per port, 200W total
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>12V DC Output:</strong> 12.6V⎓30A, 378W total
                          <ul class="circle">
                            <li>DC5521 port: 5A Max</li>
                            <li>Anderson Powerpole port: 30A Max</li>
                          </ul>
                        </li>
                      </ul>
                      <hr />
                    </li>
                    <li>
                      DC Input:
                      <ul>
                        <li>
                          <strong>High-PV Input:</strong> XT60 Port
                          <ul class="none">
                            <li>30V-150V⎓, 15A, 1600W Max</li>
                          </ul>
                        </li>
                        <li>
                          <strong>Low-PV Input / Car Input:</strong> XT60 Port
                          <ul class="none">
                            <li>PV Input: 11V-60V⎓, 20A, 1000W Max</li>
                            <li>Car Input: 12V⎓8A Max / 48V⎓20A Max</li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Battery",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Rated Capacity:</strong> 4096Wh 51.2V⎓80Ah
                    </li>
                    <li>
                      <strong>Battery Chemistry:</strong> LFP (LiFePO4)
                    </li>
                    <li>
                      <strong>Cycle life:</strong> Battery maintains 80%+ SoH
                      (State of Health) after 4000 cycles
                    </li>
                    <li>
                      <strong>IP Rating:</strong> P65 (Internal battery pack
                      only)
                    </li>
                    <li>
                      <strong>Protection Type:</strong> Over Voltage Protection,
                      Overload Protection, Over Temperature Protection, Short
                      Circuit Protection, Low Temperature Protection, Low
                      Voltage Protection, Overcurrent Protection
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Environmental Temperature",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Optimal Operating Temperature:</strong> 68° to
                      86°F
                    </li>
                    <li>
                      <strong>Discharge Temperature:</strong> 14° to 113°F
                    </li>
                    <li>
                      <strong>Charge Temperature:</strong> 32° to 113°F
                    </li>
                    <li>
                      <strong>Storage Temperature:</strong> 14° to 113°F
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Communications",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>WLAN:</strong> Wi-Fi 4 (802.11n)
                    </li>
                    <li>
                      <strong>Bluetooth:</strong> Bluetooth 5.0
                    </li>
                    <li>
                      <strong>CAN:</strong> REMOTE Port (RJ45)
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Photos</SlugHeading>
        <ImageSet
          size={3}
          maxShow={6}
          images={[
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1957.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1957.webp",
              alt: "DELTA Pro 3: front left",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1961.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1961.webp",
              alt: "DELTA Pro 3: front",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1969.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1969.webp",
              alt: "DELTA Pro 3: front right",
            },

            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1965.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1965.webp",
              alt: "DELTA Pro 3: left side port showing",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1963.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1963.webp",
              alt: "DELTA Pro 3: back ports showing",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1967.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1967.webp",
              alt: "DELTA Pro 3: right side ports showing",
            },

            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1958.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1958.webp",
              alt: "DELTA Pro 3: front left side port showing",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1962.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1962.webp",
              alt: "DELTA Pro 3: back ports closed",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1971.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1971.webp",
              alt: "DELTA Pro 3: front right side ports showing",
            },

            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1964.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1964.webp",
              alt: "DELTA Pro 3: left side",
            },
            {
              lg: "/images/products/ecoflow/delta-pro-3/lg/1968.webp",
              sm: "/images/products/ecoflow/delta-pro-3/sm/1968.webp",
              alt: "DELTA Pro 3: right side",
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Accessories</SlugHeading>

        <SlugHeading tag="h3">DC Fuse Panel</SlugHeading>
        <p>
          Learn how to safely connect 12V accessories (fridge, heater, lights,
          etc.) to your EcoFlow using a DC fuse block:
        </p>
        <ReviewItem href={namedRoutes.ecoflow.wiring12v} />
        <Accordion
          right
          items={[
            {
              preview: (
                <AccordionPreview
                  headingAs="h4"
                  prefix="Fuse block"
                  heading="Blue Sea Systems 5026 Fuse Block"
                  src="/images/products/blue-sea-systems/5026.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    There is also a 6 circuit model available (
                    <Link
                      affiliate="https://amzn.to/43tntjR"
                      href="https://www.amazon.com/dp/B000THQ0CQ"
                    >
                      5025
                    </Link>
                    ), but currently costs more and it's nice to have room to
                    add extra circuits in the future.
                  </p>
                  <p>
                    <strong>Model:</strong> 5026
                    <br />
                    <strong>Circuits:</strong> 12
                    <br />
                    <strong>Max Amperage:</strong> 30A per circuit (100A total)
                    <br />
                    <strong>Max Voltage:</strong> 32V DC
                    <br />
                    <strong>Fuse Type:</strong> ATO® or ATC®
                  </p>
                  <p>
                    You will also need to purchase the appropriate fuses to
                    match the wiring of your circuits. These can be purchased{" "}
                    <Link
                      affiliate="https://amzn.to/4oLUFvA"
                      href="https://www.amazon.com/dp/B00FLZRJJO"
                    >
                      individually
                    </Link>{" "}
                    or in a{" "}
                    <Link
                      affiliate="https://amzn.to/4r0jiGd"
                      href="https://www.amazon.com/dp/B00CQ8ILFA"
                    >
                      multi-pack
                    </Link>
                    . Be sure to use a reputable brand as these are used to
                    prevent an electrical fire.
                  </p>
                  <ButtonList>
                    <Button
                      affiliate="https://amzn.to/4qXtEXd"
                      href="https://www.amazon.com/dp/B001P6FTHC"
                      icon="Amazon"
                      secondary
                    >
                      Buy on Amazon
                    </Button>
                  </ButtonList>
                </Fragment>
              ),
            },
            {
              preview: (
                <AccordionPreview
                  headingAs="h4"
                  prefix="Anderson to ring terminal"
                  heading="10AWG 45A"
                  src="/images/products/paekq-10awg-anderson-ring.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    Allows you to safely connect a DC fuse block to your power
                    station's Anderson Powerpole port.
                  </p>
                  <p>
                    <strong>Length:</strong> 25in
                    <br />
                    <strong>Gauge:</strong> 10AWG
                    <br />
                    <strong>Max Amperage:</strong> 45A (comes with 30A fuse)
                    <br />
                    <strong>Fuse Type:</strong> ATC®
                  </p>
                  <ButtonList>
                    <Button
                      affiliate="https://amzn.to/3JCH7TQ"
                      href="https://www.amazon.com/dp/B0B2P5JDX7"
                      icon="Amazon"
                      secondary
                    >
                      Buy on Amazon
                    </Button>
                  </ButtonList>
                </Fragment>
              ),
            },
          ]}
        />

        <br />

        <SlugHeading tag="h3">Alternator Chargers</SlugHeading>
        <p>
          More reliable than solar, these units pull power from your vehicle to
          quickly charge your power station as you drive.
        </p>
        <ul class="none">
          <li>
            <ReviewItem
              href={namedRoutes.ecoflow.altCharger.quick}
              description="500W & 800W Models"
            />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.altCharger.gen2} />
          </li>
        </ul>
        <br />

        <SlugHeading tag="h3">Solar Panels</SlugHeading>
        <p>
          EcoFlow offers both{" "}
          <Link
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/collections/mountable-solar-panels"
          >
            mountable
          </Link>{" "}
          and{" "}
          <Link
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/collections/portable-solar-panels"
          >
            portable
          </Link>{" "}
          solar panels, some of which are rigid, flexible, traditional, or
          bifacial. While EcoFlow provides various solar panel options and
          bundles, always prioritize panels that physically fit your vehicle;
          using other reputable brands is perfectly fine.
        </p>
        <br />

        <SlugHeading tag="h3">Extra Batteries</SlugHeading>
        <p>
          Supports two of the following extra batteries. Some of EcoFlow's
          alternator chargers use the same expansion port which can limit you to
          a single extra battery. See full{" "}
          <Link
            href={`${namedRoutes.ecoflow.batteryCompatibility}?system=DELTA+Pro+3`}
          >
            battery compatibility details
          </Link>
          .
        </p>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-pro-3-extra-battery?variant=41385808199753"
              img="/images/products/ecoflow/delta-pro-3-smart-extra-battery/front-right.webp?v=2"
              title="DELTA Pro 3 Smart Extra Battery"
              description={<Fragment>4096Wh extra battery</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-pro-smart-extra-battery?variant=40558805385289"
              img="/images/products/ecoflow/delta-pro-smart-extra-battery/front-right.webp"
              title="DELTA Pro Smart Extra Battery"
              description={<Fragment>3600Wh extra battery</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
        </ul>

        <p>
          The{" "}
          <Link
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/products/delta-pro-3-extra-battery?variant=41385808199753"
          >
            DELTA Pro 3 Smart Extra Battery
          </Link>{" "}
          is the ideal choice because it matches the DELTA Pro 3's 4,096Wh
          capacity and stacks cleanly on top. The rubber feet on the extra
          battery sit neatly inside the recessed handles of the power station,
          which helps keep it securely aligned.
        </p>

        <SlugHeading tag="h3">Other Accessories</SlugHeading>
        <p>Remote control, solar cables, and adapters:</p>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-pro-remote-control?variant=39428709351497"
              img="/images/products/ecoflow/accessories/remote-control.webp"
              title="Remote Control"
              titleSuffix="(wired only)"
              description={<Fragment>Remote monitoring and control</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/ev-x-stream-adapter-delta-pro-ultra?variant=40758561964105"
              img="/images/products/ecoflow/accessories/ev-x-stream-adapter-delta-pro-ultra.webp"
              title="EV X-Stream Adapter"
              description={
                <Fragment>
                  7200W charging via EV station (J1772 connector)
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
        </ul>
        <Accordion
          items={[
            {
              heading: "View More",
              content: (
                <Fragment>
                  <ul class="none">
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/collections/delta-3-series-accessories/products/solar-charging-cable?variant=39880496382025"
                        img="/images/products/ecoflow/accessories/solar-to-xt60-xt60i-charging-cable.webp"
                        title="Solar to XT60/XT60i Charging Cable"
                        description={
                          <Fragment>Charge from solar panels</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/solar-extension-cable?_pos=1&_sid=e350c6fc3&_ss=r&variant=31865877823561"
                        img="/images/products/ecoflow/accessories/solar-extension-cable.webp"
                        title="Solar Extension Cable"
                        description={
                          <Fragment>Provides additional cable length</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/solar-parallel-connection-cable?variant=31289813729353"
                        img="/images/products/ecoflow/accessories/solar-parallel-connection-cable.webp"
                        title="Solar Parallel Connection Cable"
                        description={
                          <Fragment>Connects solar panels in parallel</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393"
                        img="/images/products/ecoflow/accessories/smart-generator-adapter.webp"
                        title="Smart Generator Adapter"
                        description={
                          <Fragment>
                            For use with Alternator Charger or Smart Generator
                            (XT150 cables)
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/car-charging-cable?variant=39308519604297"
                        img="/images/products/ecoflow/accessories/car-charging-cable.webp"
                        title="Car Charging Cable"
                        description={
                          <Fragment>
                            Charge from your vehicle's cigarette lighter socket
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/collections/rv-ev-power-accessories/products/portable-power-station-grounding-adapter?variant=39987909984329"
                        img="/images/products/ecoflow/accessories/portable-power-station-grounding-adapter.webp"
                        title="Portable Power Station Grounding Adapter"
                        description={
                          <Fragment>
                            Neutral-ground bonding prevents floating ground
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h3">Suggestions to EcoFlow</SlugHeading>
        <Accordion
          items={[
            {
              heading: "My suggestions and feedback ",
              content: (
                <Fragment>
                  <p>
                    A few things I would like to see improved on the next
                    version:
                  </p>
                  <ul>
                    <li>
                      <strong>Higher amperage DC output:</strong> Increasing the
                      12V output to 50A or higher would give heavy DC users more
                      headroom and better differentiate this heavy‑duty unit
                      from EcoFlow's smaller DELTA 3 Max Plus and DELTA 3 Ultra
                      Plus.
                    </li>
                    <li>
                      <strong>Configurable DC output voltage:</strong> Allowing
                      users to manually set the DC output voltage anywhere
                      between 12V and 24V (or 48V) would offer massive
                      flexibility for running a wider variety of van appliances
                      without relying on external step-up converters.
                    </li>
                    <li>
                      <strong>Bring back the car outlet:</strong> Most other
                      power stations have a DC cigarette port which allows for
                      devices such as fridges to be easily connected. To improve
                      on this further, it could use a locking marine‑grade port
                      so it isn't prone to wiggling free due to road vibration.
                    </li>
                    <li>
                      <strong>Add more USB ports:</strong> So many modern
                      devices use USB. I think it should contain at least 4x USB
                      C and 4x USB A.
                    </li>
                    <li>
                      <strong>Relocate side ports:</strong> Cables sticking out
                      the side are prone to getting bumped, especially the
                      smaller DC cables. The new{" "}
                      <Link
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?view=d3up&variant=54718705008713"
                      >
                        DELTA 3 Ultra Plus
                      </Link>{" "}
                      resolved this by placing all its ports on the front and
                      back. However, when doing so it's important to provide
                      easy access to the DC on/off button.
                    </li>
                    <li>
                      <strong>More compact footprint:</strong> The current wheel
                      design wastes valuable space and prevents the unit from
                      sitting flush against a wall or beside gear.
                    </li>
                    <li>
                      <strong>CarPlay and Android Auto integration:</strong>{" "}
                      Adding infotainment app support would allow drivers to
                      monitor solar input, power consumption, and battery
                      capacity, or quickly toggle the AC and DC outlets right
                      from their vehicle's dashboard screen while driving.
                    </li>
                    <li>
                      <strong>Battery expansion adapter compatibility:</strong>{" "}
                      Add compatibility with EcoFlow's{" "}
                      <Link
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/ecoflow-extra-battery-expansion-adapter?variant=55507615645769"
                      >
                        Extra Battery Expansion Adapter
                      </Link>
                      , used on the DELTA 3 Max Plus and Ultra Plus, to split
                      one port into two. This would expand the system limit to
                      four batteries across its two ports. Additionally, it
                      would allow users to run the EcoFlow 800W or Plus 1000
                      alternator chargers alongside multiple extra batteries
                      which use the same ports.
                    </li>
                    <li>
                      <strong>Support for chained expansion batteries:</strong>{" "}
                      Allowing extra batteries to be chained together
                      sequentially would remove the current two-battery limit
                      imposed by the two physical ports, giving users an easy
                      path to much higher capacity storage.
                    </li>
                    <li>
                      <strong>Expanded battery support:</strong> The unit should
                      support EcoFlow's smaller expansion packs, including the
                      DELTA 3 Max Plus and DELTA 3 Series Smart Extra Batteries,
                      instead of limiting users to the heavy DELTA Pro lineup.
                      Adding the ability to connect generic third-party lithium
                      batteries into the system would also be a massive upgrade
                      for van owners who want to scale their storage using more
                      affordable standard batteries.
                    </li>
                    <li>
                      <strong>Quieter internal relays:</strong> When solar
                      charging initiates during low-light morning conditions,
                      the internal relays can click on and off repeatedly until
                      the panels get stable sunlight. While this is expected
                      behavior, using quieter or noise-dampened relays would be
                      a huge plus for light sleepers.
                    </li>
                    <li>
                      <strong>Add self-heating:</strong> Allow for use where
                      internal temperature could drop below 14°F like is done in
                      the EcoFlow DELTA Pro Ultra.
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">My Verdict</SlugHeading>
        <p>
          The <strong>EcoFlow DELTA Pro 3</strong> is a very capable power
          station that's packed with features and ready to power almost any
          adventure on the road. If you’re considering an all‑in‑one, it's
          difficult to beat the DELTA Pro 3. With a 4,000W inverter, dual solar
          inputs (1,600W, 1,000W), a native 30A DC port, and a 4,096Wh base
          battery that scales to 12.2kWh, it offers a powerful alternative to a
          full DIY electrical system.
        </p>
        <p>
          For those with a traditional living space, it works extremely well as
          a backup option and helps avoid losing a fridge full of food during an
          outage. When the power goes out, you can roll it inside and keep your
          refrigerator and other essential loads powered.
        </p>
        <p>
          If you're looking for a more affordable option, the original{" "}
          <Link
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569"
          >
            Delta Pro
          </Link>{" "}
          and the new{" "}
          <Link
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?view=d3up&variant=54718705008713"
          >
            DELTA 3 Ultra Plus
          </Link>{" "}
          are both strong alternatives worth considering.
        </p>
        <EcoFlowCouponCode
          href="https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105"
          buttonText="Buy from EcoFlow"
        />

        <p>
          Not sure it’s the best fit? My{" "}
          <Link href={namedRoutes.powerSystems}>power systems guide</Link>{" "}
          covers all the popular brands.
        </p>

        <ButtonList>
          <Button
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105"
            icon="EcoFlow"
          >
            Buy from EcoFlow
          </Button>
          <Button
            affiliate="https://amzn.to/3MkrPnm"
            href="https://www.amazon.com/dp/B0D14FMFZD/"
            secondary
            icon="Amazon"
          >
            Buy on Amazon
          </Button>
        </ButtonList>

        <Tags tags={headerInfo.tags} brands={headerInfo.brands} />
      </Center>
      <Center>
        <h3>Related</h3>
        <ul class="none">
          <li>
            <ReviewItem href={namedRoutes.ecoflow.vanlife} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.dp} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.d3ultraPlus} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.inventory.vanlife} />
          </li>
        </ul>
      </Center>
      <Questions />
      <Center>
        <Author
          author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />
      </Center>
      <StickyButtons
        title="EcoFlow DELTA Pro 3"
        description={
          <Fragment>
            $2,599 <s>$3,699</s> | 4,096Wh
          </Fragment>
        }
      >
        <Button
          affiliateData={affiliateMerchants.ecoflow}
          href="https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105"
          icon="EcoFlow"
        >
          View on EcoFlow
        </Button>
        <Button
          affiliate="https://amzn.to/3MkrPnm"
          href="https://www.amazon.com/dp/B0D14FMFZD/"
          secondary
          icon="Amazon"
        >
          View on Amazon
        </Button>
      </StickyButtons>
    </Editorial>
  </div>
);

export default Page;
